import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useApi } from "@/lib/api";

const MeCtx = createContext(null);

export function MeProvider({ children }) {
  const api = useApi();
  const [me, setMe] = useState(null);
  const [failed, setFailed] = useState(false);
  const [blocked, setBlocked] = useState(null);
  const refresh = useCallback(async () => {
    try { setMe(await api("get", "/me")); setFailed(false); }
    catch (e) {
      const d = e?.response?.data?.detail;
      if (d?.code === "blocked") setBlocked({ reason: d.reason }); else setFailed(true);
    }
  }, [api]);
  useEffect(() => { refresh(); }, [refresh]);
  const value = useMemo(() => ({ me, setMe, refresh, failed, blocked }), [me, refresh, failed, blocked]);
  return <MeCtx.Provider value={value}>{children}</MeCtx.Provider>;
}

export const useMe = () => useContext(MeCtx);
